export const FORGET_USER = 'login_user';
export const FORGET_USER_SUCCESSFUL = 'login_user_successfull';

export const API_FAILED = 'api_failed';